import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/src/app/contact-french/components/ContactDetailsFrench.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/src/components/common/Header.tsx");
